module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dBe6e"))).then(() => parcelRequire('f4eak'));